import React from 'react';
import { useNavigate } from 'react-router-dom';
import FundSelector from '../components/FundSelector';
import { usePortfolio } from '../context/PortfolioContext';

const SelectFundsPage = () => {
  const navigate = useNavigate();
  const {
    selectedFunds,
    setSelectedFunds,
    scannedFunds,
    navData,
    handleScanComplete,
    handleScanError,
    markStepCompleted,
  } = usePortfolio();

  const handleNext = () => {
    markStepCompleted(1);
    navigate('/optimize');
  };

  return (
    <div className="container page-container">
      <div className="page-header">
        <h2>Step 1: Select Your Funds</h2>
        <p>Scan your portfolio screenshot or search manually</p>
      </div>

      <section className="section">
        <FundSelector
          selectedFunds={selectedFunds}
          onFundsChange={setSelectedFunds}
          onScanComplete={handleScanComplete}
          onScanError={handleScanError}
        />
      </section>

      {/* Display scanned funds if any */}
      {scannedFunds.length > 0 && (
        <section className="section" style={{ marginTop: '1rem' }}>
          <h3>Scanned Funds ({scannedFunds.length})</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '1rem' }}>
            {scannedFunds.map((item, idx) => {
              const bestMatch = item.matches?.[0];
              const extracted = item.extracted;

              return (
                <div
                  key={idx}
                  style={{
                    background: '#f9f9f9',
                    padding: '1rem',
                    borderRadius: '8px',
                    borderLeft: bestMatch ? '4px solid #4CAF50' : '4px solid #ff9800'
                  }}
                >
                  <div style={{ fontWeight: '600', marginBottom: '0.5rem' }}>
                    {extracted.name}
                  </div>
                  {bestMatch ? (
                    <div>
                      <div style={{ fontSize: '0.9rem', color: '#666' }}>
                        → {bestMatch.scheme_name.substring(0, 70)}...
                      </div>
                      <div style={{ fontSize: '0.85rem', color: '#4CAF50', marginTop: '0.25rem' }}>
                        ✓ {(bestMatch.similarity * 100).toFixed(0)}% confidence
                        {item.matches.length > 1 && ` (+${item.matches.length - 1} alternatives)`}
                      </div>
                    </div>
                  ) : (
                    <div style={{ fontSize: '0.9rem', color: '#ff9800' }}>
                      ⚠️ No close match found
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      )}

      {/* Selected Funds Summary */}
      {selectedFunds.length > 0 && (
        <section className="section" style={{ background: '#f0f7ff' }}>
          <h3>✅ Selected Funds ({selectedFunds.length})</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '1rem' }}>
            {selectedFunds.map((fund, idx) => (
              <div
                key={fund.schemeCode}
                style={{
                  background: 'white',
                  padding: '0.75rem',
                  borderRadius: '6px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <strong>{idx + 1}.</strong> {fund.schemeName.substring(0, 60)}...
                </div>
                <button
                  onClick={() => setSelectedFunds(prev => prev.filter(f => f.schemeCode !== fund.schemeCode))}
                  style={{
                    background: '#ff4444',
                    color: 'white',
                    border: 'none',
                    padding: '0.3rem 0.8rem',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.85rem'
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        </section>
      )}

      {selectedFunds.length >= 2 && navData && (
        <div className="page-actions">
          <button className="btn-next" onClick={handleNext}>
            Next: Set Parameters →
          </button>
        </div>
      )}
    </div>
  );
};

export default SelectFundsPage;
